export default __webpack_public_path__ + "media/images/images/jvqmap/flag-328421e9da32eaa2a7ac7c11e8372e54.png";